import converterFactory from '../converterFactory'
import headlineFactory from '../headlineFactory'
import ArcUUID from '~/util/arc-identifiers'

export function toClipboardContent(story) {
  const { additional_properties: { clipboard = {} } = {} } = story
  const clipboardTypes = Object.keys(clipboard) || []
  return clipboardTypes.reduce((result, type) => {
    result[type] = clipboard[type].map((ans) => {
      const draftContent = converterFactory.toDraftContent([ans])
      return draftContent.merge({
        clipboardANS: ans,
        key: ArcUUID.create(),
      })
    })
    return result
  }, {})
}

export function toRelatedContent(story) {
  const { related_content: { basic = [] } = {} } = story

  return basic.reduce((result, ans) => {
    const type = ans.referent ? ans.referent.type : ans.type
    result[type] = result[type] || []
    const draftContent = converterFactory.toDraftContent([ans])
    result[type].push(
      draftContent.merge({
        clipboardANS: ans,
        key: ArcUUID.create(),
      })
    )
    return result
  }, {})
}

export function ansToDraftContent(story) {
  if (!story || !story.content_elements) {
    throw new Error('Can not convert empty story')
  }

  return {
    mainDraftContent: converterFactory.toDraftContent(story.content_elements),
    clipboardContent: toClipboardContent(story),
    relatedContent: toRelatedContent(story),
  }
}

export function ansToHeadlineContent(story) {
  return new Promise((resolve, reject) => {
    if (!story) {
      reject(new Error(`Can not convert empty story`))
    } else {
      try {
        resolve({
          headlineDraftContent: headlineFactory.toDraftContent([
            {
              ...story.headlines,
              type: 'headline',
            },
          ]),
          subheadlineDraftContent: headlineFactory.toDraftContent([
            {
              ...story.subheadlines,
              type: 'subheadline',
            },
          ]),
        })
      } catch (e) {
        reject(e)
      }
    }
  })
}
